// ROE application field configuration (simplified)
// Note: Manual/Bulk submission type, Excel upload and exam results table were removed per latest requirements.
// Only core exam details remain; conducted-by is auto-populated & disabled in UI.

export const ROE_APPLICATION_FIELDS = [
    {
        sectionID: 'exam-details',
        sectionName: 'Exam Details',
        fieldList: [
            {
                id: 'exam-type',
                label: 'Type of Examination',
                type: 'dropdown',
                apiID: 'LicenceCategory',
                options: [
                    { optID: 'General Operator\'s Certificate (GOC)', optLabel: 'General Operator\'s Certificate (GOC)' },
                    { optID: 'Restricted Operator\'s Certificate (ROC)', optLabel: 'Restricted Operator\'s Certificate (ROC)' }
                ],
                rule: { required: true }
            },
            {
                id: 'exam-date',
                label: 'Date of Examination',
                type: 'date',
                rule: {
                    required: true,
                    customValidate: ({ currentValue }: any) => {
                        if (!currentValue) return 'Exam date is required';
                        const today = new Date();
                        const selected = new Date(currentValue);
                        const todayYMD = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        if (selected > todayYMD) return 'Future date is not allowed';
                        return true;
                    }
                }
            },
            {
                id: 'exam-conducted-by',
                label: 'Exam Conducted By',
                type: 'text',
                rule: { disabled: true, required: true }
            },
            {
                id: 'submission-type',
                label: 'Submission Type',
                type: 'radio',
                apiID: 'SubmissionType',
                options: [
                    { optID: 'ST1', optLabel: 'Manual Entry' },
                    { optID: 'ST2', optLabel: 'Bulk Upload' }
                ],
                rule: { required: true }
            },
            {
                id: 'exam-results',
                label: 'Exam Results',
                type: 'examResultsDataSet', // custom renderer in FormGenerator
                options: [],
                span: 12,
                rule: {
                    required: true,
                    // Custom required: at least one row must be present regardless of mode
                    customValidate: ({ getValues }: any) => {
                        const rows = getValues('exam-details-exam-results') || getValues('exam-results');
                        if (!Array.isArray(rows) || rows.length === 0) return 'Please provide at least one exam result';
                        return true;
                    }
                }
            }
        ]
    }
];
